import React from 'react';
import { useIntl } from 'react-intl';

interface ITruncatedLinkProps {
    href: string;
    text: string;
    download?: string;
    className?: string;
}

export function TruncatedLink({ href, text, download, className }: ITruncatedLinkProps) {
    const intl = useIntl();
    return (
        <a
            className={['d-block', 'text-truncate', className].filter(Boolean).join(' ')}
            href={href}
            download={download}
            target="_blank"
            rel="noopener noreferrer"
            title={text}
        >
            {text}
            <span className="usa-sr-only">{intl.formatMessage({ id: 'common.link.title.newTab' })}</span>
        </a>
    );
}
